import { apiClient } from '@doda/api-client/util/apiClient';
import type { DailyClicksUpdateRequest } from '@doda/api-client/aspida/@types';

/** 日別クリック数更新 */
export function clicksCountUp(jid: string, body: DailyClicksUpdateRequest) {
  return apiClient.api.v1.job
    ._jid(jid)
    .clicksCountUp.$post({ body })
    .catch((error) => {
      window.DD_LOGS?.logger.info('clicksCountUp failed: ', error);
    });
}
